<template>
  <b-modal
    v-model="output"
    :title="title"
    :header-bg-variant="headerVariant"
    :size="size"
    v-bind="$attrs"
    no-close-on-backdrop
    @change="updateValue"
  >
    <LoadingSpinner :loading="loading" :text="loadingSpinnerText" />
    <div v-if="!loading">
      <div v-html="description" :class="dynamicClass"></div>
      <slot name="extra-area"></slot>
      <slot name></slot>
    </div>
    <template #modal-footer>
      <div v-show="!loading">
        <b-button class="margin-left-8" :variant="cancelVariant" @click="cancel()">
          <mdicon name="close" size="20" />
          {{ $lang.no }}
        </b-button>
        <b-button :variant="okVariant" @click="ok($event)">
          <mdicon name="check" size="20" />
          {{ $lang.yes }}
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import LoadingSpinner from "./LoadingSpinner";

export default {
  name: "confirm",
  components: { LoadingSpinner },
  props: {
    title: String,
    description: String,
    headerVariant: {
      type: String,
      default: "danger",
    },
    cancelVariant: {
      type: String,
      default: "outline-danger",
    },
    okVariant: {
      type: String,
      default: "success",
    },
    size: {
      type: String,
      default: "md",
    },
    value: {
      type: Boolean,
      default: false,
    },
    dynamicClass: {
      type: String,
      default: "d-flex",
    },
    loading: {
      type: Boolean,
      default: false,
    },
    preventDefault: {
      type: Boolean,
      default: false,
    },
    loadingSpinnerText: {
      type: String,
      default: "درحال حذف اطلاعات...",
    },
  },
  data() {
    return {
      output: this.value,
    };
  },
  methods: {
    updateValue() {
      this.$emit("input", this.output);
    },
    cancel() {
      this.$emit("cancel");
    },
    ok(e) {
      this.preventDefault && e.preventDefault();
      this.$emit("ok");
    },
  },
  watch: {
    value() {
      this.output = this.value;
    },
  },
};
</script>

<style></style>
